import { Reducer } from 'redux'
import { WAFRAssessmentForm } from './actions'
import { awsRegions } from '../../../common/utils/awsRegions'

export const emptyWorkloadAssesment = {
  workloadName: '',
  reviewOwner: '',
  description: '',
  envirionment: '',
  hostedRegion: '',
  architecturalDesign: '',
  industryType: '',
  industryName: '',
  scope: [
    {
      accountId: '',
      awsRegions: [
        {
          region: '',
          regionName: '',
        },
      ],
    },
  ],
}

export interface WAFRQuestion {
  questionId: string
  pillarId: string
  questionTitle: string
  status?: string
  questionReferenceNumber: string
}

export interface QuestionsByPillar {
  [key: string]: WAFRQuestion[]
}

export interface SubRoute {
  key: string | number
  path: string
  name: string
  disabled: boolean
  icon: () => JSX.Element
}

export interface CreationRoute {
  key: number
  path: string
  name: string
  disabled: boolean
  divider?: boolean
  endIcon?: () => JSX.Element
  subRoutes?: SubRoute[]
}
export interface QuestionStatus {
  is_answered: boolean
  is_flagged: boolean
}

export interface PillarStatus {
  [questionId: string]: QuestionStatus
}

export interface StatusItem {
  [pillarId: string]: PillarStatus[]
}

export enum WAFRAssessmentSectionName {
  PAGE_MARKER = 'pageMarker',
  CREATE_ASSESSMENT_INFORMATION = 'createAssessmentInfo',
}

export interface CreateWAFRAssessmentResponse {
  workloadId: string
  workloadArn: string
}
export interface CreateWAFRAssessmentRequest {
  workloadName: string
  description: string
  reviewOwner: string
  environment: string
  hostedRegion: string
  industryType?: string
  industry?: string
  architecturalDesign?: string
  lenses: string[]
  scope: AWSScopes[]
  workloadArn?: string
}

export interface WAFRAssessmentFormDetails {
  workloadId?: string
  workloadArn?: string
  workloadName: string
  description: string
  environment: string
  updatedAt?: string
  reviewOwner: string
  isReviewOwnerUpdateAcknowledged?: boolean
  improvementStatus?: string
  riskCounts?: {
    unanswered: number
    high: number
    medium: number
    none: number
    notApplicable: number
  }
  pillarPriorities?: string[]
  lenses?: string[]
  owner?: string
  tags?: Record<string, string>
  hostedRegion: string
  architecturalDesign?: string
  industryType?: string
  industry?: string
  scope: AWSScopes[]
}

export interface AwsRegions {
  region: string
  regionName: string
}

export interface AWSScopes {
  accountId: string
  awsRegions: string[] | AwsRegions[]
}
export type ScopeItem = {
  accountId: string
  awsRegions: string[]
}

export interface AwsAccountDetails {
  awsAccountId: string
  awsAccountRegion: AwsRegions[]
}

export type Sections = {
  [WAFRAssessmentSectionName.CREATE_ASSESSMENT_INFORMATION]: WAFRAssessmentFormDetails
}

export interface WAFRCreateAssessmentState {
  createAssessmentForm: Sections
  questions: WAFRQuestion[]
  status: []
  questionId?: string
  questionReferenceNumber?: string
  initialDelay?: boolean
}

export const initialState: WAFRCreateAssessmentState = {
  createAssessmentForm: {} as Sections,
  questions: [],
  status: [],
  questionId: 'priorities',
  questionReferenceNumber: '',
  initialDelay: false,
}

type actionType = {
  type:
    | WAFRAssessmentForm.SET_WAFR_CREATE_ASSESSMENT_FORM
    | WAFRAssessmentForm.SET_WAFR_QUESTIONS
    | WAFRAssessmentForm.SET_WAFR_QUESTION_ID
    | WAFRAssessmentForm.SET_WAFR_QUESTION_REF_NO
    | WAFRAssessmentForm.SET_DELAY
    | WAFRAssessmentForm.REMOVE_DELAY
    | WAFRAssessmentForm.SET_STATUS
  payload: Sections | WAFRQuestion[] | string
}

export const reducer: Reducer<WAFRCreateAssessmentState, actionType> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case WAFRAssessmentForm.SET_WAFR_CREATE_ASSESSMENT_FORM: {
      return {
        ...state,
        createAssessmentForm: action.payload as Sections,
      }
    }
    case WAFRAssessmentForm.SET_WAFR_QUESTIONS: {
      return {
        ...state,
        questions: action.payload as WAFRQuestion[],
      }
    }
    case WAFRAssessmentForm.SET_WAFR_QUESTION_ID: {
      return {
        ...state,
        questionId: action.payload as string,
      }
    }
    case WAFRAssessmentForm.SET_WAFR_QUESTION_REF_NO: {
      return {
        ...state,
        questionReferenceNumber: action.payload as string,
      }
    }
    case WAFRAssessmentForm.SET_DELAY: {
      return {
        ...state,
        initialDelay: true,
      }
    }
    case WAFRAssessmentForm.REMOVE_DELAY: {
      return {
        ...state,
        initialDelay: false,
      }
    }
    case WAFRAssessmentForm.SET_STATUS: {
      return {
        ...state,
        status: action.payload as [],
      }
    }
    default: {
      return state
    }
  }
}
